module.exports = __webpack_public_path__ + "img/DNARepair-BLCA_GSE171351.f6d8fc2c.png";